import { render, staticRenderFns } from "./help-icon.vue?vue&type=template&id=18d64e63&scoped=true"
import script from "./help-icon.vue?vue&type=script&lang=js"
export * from "./help-icon.vue?vue&type=script&lang=js"
import style0 from "./help-icon.vue?vue&type=style&index=0&id=18d64e63&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d64e63",
  null
  
)

export default component.exports